import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type {
  AdminPagination,
  AdminProjectListItem,
} from "../../../domain/administrator/model";

type AdminProjectListState = AdminPagination<AdminProjectListItem> & {
  loading: boolean;
  error: unknown;
};

const initialState: AdminProjectListState = {
  loading: false,
  docs: [],
  totalDocs: 0,
  limit: 0,
  totalPages: 0,
  page: 0,
  pagingCounter: 0,
  hasPrevPage: false,
  hasNextPage: false,
  prevPage: null,
  nextPage: null,
  error: null,
};

const dataSlice = createSlice({
  name: "Projects/list",
  initialState: initialState,
  reducers: {
    eraseAdminListProjectsStore: () => {
      return { ...initialState };
    },
    setAdminListProjectsLoading: (state) => {
      state.loading = true;
    },
    setAdminListProjectsResults: (
      state,
      action: PayloadAction<AdminPagination<AdminProjectListItem>>,
    ) => {
      state.loading = false;
      state.docs = action.payload.docs;
      state.totalDocs = action.payload.totalDocs;
      state.limit = action.payload.limit;
      state.totalPages = action.payload.totalPages;
      state.page = action.payload.page;
      state.pagingCounter = action.payload.pagingCounter;
      state.hasPrevPage = action.payload.hasPrevPage;
      state.hasNextPage = action.payload.hasNextPage;
      state.prevPage = action.payload.prevPage;
      state.nextPage = action.payload.nextPage;
      state.error = null;
    },
    setAdminListProjectsFailure: (state, action: PayloadAction<unknown>) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  eraseAdminListProjectsStore,
  setAdminListProjectsFailure,
  setAdminListProjectsLoading,
  setAdminListProjectsResults,
} = dataSlice.actions;

export default dataSlice.reducer;
